import { useMutation } from '@tanstack/react-query';
import { rpcClient } from 'src/api/rpc/client';

export function useAssistStepConfig() {
  return useMutation<
    {
      config: Record<string, unknown>;
      explanation: string;
    },
    Error,
    {
      stepType: string;
      currentConfig: Record<string, unknown>;
      configSchema?: Record<string, unknown>;
      stepDescription?: string;
      instruction: string;
    }
  >({
    mutationFn: async (params) => {
      return await rpcClient.workflows.assistStepConfig(params);
    },
  });
}
